// CombineReducers
import {combineReducers} from 'redux';
import createRefState from "./createRefInfo";
import searchRefState from "./searchRefInfo";
import showRefState from "./showRefInfo";

const rootReducer = combineReducers({
    createRefState,
    searchRefState,
    showRefState
});

export default rootReducer;